import { CountryCodeModel } from "services/api/cplapi/CPLAPI";

export interface CountryOption {
  countryCodeID: number;
  sortOrder: number;
  commonName: string;
  isO3166_1_2LetterCode: string;
}

export const toCountryOptions = (models: CountryCodeModel[]): CountryOption[] =>
  models
    .filter((model) => model.sortOrder !== undefined && model.commonName)
    .map((model) => ({
      // TODO(10417): use countryCodeID once CountryCodeModel has it; sortOrder stands in for it until then
      countryCodeID: model.sortOrder as number,
      sortOrder: model.sortOrder as number,
      commonName: model.commonName as string,
      isO3166_1_2LetterCode: model.isO3166_1_2LetterCode ?? "",
    }))
    .sort((a, b) => a.sortOrder - b.sortOrder);

export const findCountryByIsoCode = (countries: CountryOption[], isoCode: string): CountryOption | undefined =>
  countries.find((country) => country.isO3166_1_2LetterCode.toUpperCase() === isoCode.toUpperCase());
